import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function CoolToneFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.COOL_TONE}
      label="Cool"
      image="cool"
      thumbnailClassName="bg-gradient-to-br from-sky-100 via-blue-300 to-indigo-400"
    />
  );
}
